export default __webpack_public_path__ + "static/media/professionalism.4551a86d.png";